package app.nestbridge.feature.invitations.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import app.nestbridge.feature.invitations.usecase.FindInvitationByClaimTokenUseCase
import kotlinx.coroutines.launch
import app.nestbridge.app.util.launchSafely
import app.nestbridge.feature.invitations.screen.InvitationDetailScreen
import app.nestbridge.feature.invitations.screen.InvitationQrScanEvent
import app.nestbridge.feature.invitations.screen.InvitationQrScanScreen
import app.nestbridge.feature.invitations.screen.InvitationQrScanState
import app.nestbridge.feature.invitations.screen.InvitationResult
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.foundation.rememberAnsweringNavigator
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = InvitationQrScanScreen::class,
    scope = AppScope::class,
)
@Inject
class InvitationQrScanPresenter(
    @Assisted private val navigator: Navigator,
    private val findInvitationByClaimTokenUseCase: FindInvitationByClaimTokenUseCase,
) : Presenter<InvitationQrScanState> {

    @Composable
    override fun present(): InvitationQrScanState {
        val scope = rememberCoroutineScope()
        val scannedInvitationId = "invite-6"
        val detailNavigator = rememberAnsweringNavigator<InvitationResult>(navigator) {
            navigator.pop()
        }

        fun onEvent(event: InvitationQrScanEvent) {
            when (event) {
                InvitationQrScanEvent.Cancel -> navigator.pop()
                InvitationQrScanEvent.SimulateScan -> {
                    scope.launchSafely {
                        val invitation = findInvitationByClaimTokenUseCase(scannedInvitationId).getOrNull()
                        if (invitation == null) {
                            navigator.pop()
                            return@launchSafely
                        }
                        detailNavigator.goTo(
                            InvitationDetailScreen(
                                invitationId = scannedInvitationId,
                            ),
                        )
                    }
                }
            }
        }

        return InvitationQrScanState(
            eventSink = ::onEvent,
        )
    }
}
